import { withApollo } from 'react-apollo'
import Channel from './Channel'

const ApolloChannel = withApollo(Channel)
export default ApolloChannel
